import { render } from "./SaleOrderCard.vue?vue&type=template&id=cfc3d0f8&scoped=true"
import script from "./SaleOrderCard.vue?vue&type=script&lang=js"
export * from "./SaleOrderCard.vue?vue&type=script&lang=js"

import "./SaleOrderCard.vue?vue&type=style&index=0&id=cfc3d0f8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc3d0f8"]])

export default __exports__